<template>
    <div class="scenario" :class="textDir">
    <h2>{{ scenario.title }}</h2>
    <div v-html="scenario.content"></div>
    </div>
</template>
<script>
export default {
    name: 'ScenarioBlock',
    props: {
        scenario: {
            type: Object,
            required: true,
        },
        textDir: {
            type: String,
            required: true,
        },
    },
};
</script>